import React, { useState } from "react";
import { CustomerVerification } from "./customer-verification";

import { Label } from "app/components/ui/label";
import { Input } from "app/components/ui/input";
import { Button } from "app/components/ui/button";

interface Props {
  setIsRequestSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ProfileForm = ({ setIsRequestSubmitted }: Props) => {
  return (
    <div className="bg-white p-4 sm:p-5 md:p-6 lg:p-[1.625rem] border border-[#E5E7EB] rounded-lg md:rounded-2xl">
      <div className="mb-4 sm:mb-5 md:mb-6 lg:mb-[1.625rem]">
        <h3 className="font-mobile text-black text-xl sm:text-[1.375rem] lg:text-2xl font-bold leading-5 sm:leading-6 lg:leading-7 mb-1.5 sm:mb-2 lg:mb-2.5">
          Update Profile{" "}
          <span className="text-sm sm:text-[0.925rem] lg:text-base">
            (ID verification required)
          </span>
        </h3>
        <p className="text-black/50 text-xs sm:text-[0.825rem] lg:text-sm font-medium leading-3 sm:leading-4 lg:leading-5">
          Request ID: AH0619251
        </p>
      </div>
      <div className="mb-4 space-y-4 sm:space-y-5 lg:space-y-6 sm:mb-5 lg:mb-6">
        <div>
          <Label
            htmlFor="firstname"
            className="w-fit text-black text-xs sm:text-[0.825rem] md:text-sm font-medium leading-4 md:leading-5 mb-1 md:mb-[0.375rem]"
          >
            First Name
          </Label>
          <Input
            id="firstname"
            type="text"
            value="John"
            className="bg-white h-[2.35rem] sm:h-10 md:h-[2.875rem] p-2 md:p-3 border-[#D1D5DB] rounded-xl text-black text-[0.825rem] sm:text-sm font-semibold leading-4 md:leading-5 focus-visible:outline focus:outline-[#707C8F]"
          />
        </div>
        <div>
          <Label
            htmlFor="lastname"
            className="w-fit text-black text-xs sm:text-[0.825rem] md:text-sm font-medium leading-4 md:leading-5 mb-1 md:mb-[0.375rem]"
          >
            Last Name
          </Label>
          <Input
            id="lastname"
            type="text"
            value="Doe"
            className="bg-white h-[2.35rem] sm:h-10 md:h-[2.875rem] p-2 md:p-3 border-[#D1D5DB] rounded-xl text-black text-[0.825rem] sm:text-sm font-semibold leading-4 md:leading-5 focus-visible:outline focus:outline-[#707C8F]"
          />
        </div>
        <div>
          <Label
            htmlFor="email"
            className="w-fit text-black text-xs sm:text-[0.825rem] md:text-sm font-medium leading-4 md:leading-5 mb-1 md:mb-[0.375rem]"
          >
            Email
          </Label>
          <Input
            id="email"
            type="email"
            value="john.doe@example.com"
            className="bg-white h-[2.35rem] sm:h-10 md:h-[2.875rem] p-2 md:p-3 border-[#D1D5DB] rounded-xl text-black text-[0.825rem] sm:text-sm font-semibold leading-4 md:leading-5 focus-visible:outline focus:outline-[#707C8F]"
          />
        </div>
        <div>
          <Label
            htmlFor="billingAddress"
            className="w-fit text-black text-xs sm:text-[0.825rem] md:text-sm font-medium leading-4 md:leading-5 mb-1 md:mb-[0.375rem]"
          >
            Billing Address
          </Label>
          <Input
            id="billingAddress"
            type="text"
            value="123 Main St, Miami, FL 33101"
            className="bg-white h-[2.35rem] sm:h-10 md:h-[2.875rem] p-2 md:p-3 border-[#D1D5DB] rounded-xl text-black text-[0.825rem] sm:text-sm font-semibold leading-4 md:leading-5 focus-visible:outline focus:outline-[#707C8F]"
          />
        </div>
        <div>
          <Label
            htmlFor="shippingAddress"
            className="w-fit text-black text-xs sm:text-[0.825rem] md:text-sm font-medium leading-4 md:leading-5 mb-1 md:mb-[0.375rem]"
          >
            Shipping Address
          </Label>
          <Input
            id="shippingAddress"
            type="text"
            value="123 Main St, Miami, FL 33101"
            className="bg-white h-[2.35rem] sm:h-10 md:h-[2.875rem] p-2 md:p-3 border-[#D1D5DB] rounded-xl text-black text-[0.825rem] sm:text-sm font-semibold leading-4 md:leading-5 focus-visible:outline focus:outline-[#707C8F]"
          />
        </div>
        <div className="">
          <Label
            htmlFor="addNote"
            className="w-fit text-black text-xs sm:text-[0.825rem] md:text-sm font-semibold leading-4 md:leading-5 mb-1.5 md:mb-2"
          >
            Add Note
          </Label>
          <Input
            id="addNote"
            className="bg-white hover:bg-[#FAFAFA] w-full h-10 md:h-[2.875rem] p-2.5 sm:p-[0.6875rem] md:px-[0.625rem] md:py-3 border border-[#D1D5DB] rounded-lg text-black placeholder:text-black/50 text-xs sm:text-[0.8125rem] font-medium leading-4 md:leading-5 focus-visible:outline focus:outline-[#707C8F]"
            placeholder="Add note"
          />
        </div>
      </div>
      <CustomerVerification />
      <div className="flex items-center gap-2 sm:gap-3 lg:gap-[1.19rem]">
        <Button
          type="button"
          variant="outline"
          className="hover:bg-[#FAFAFA] h-[2.35rem] sm:h-10 md:h-11 lg:h-11 p-[0.625rem] border-[#E9EAEB] text-black"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="primary"
          className="w-full"
          onClick={() => setIsRequestSubmitted(true)}
        >
          Update Profile
        </Button>
      </div>
    </div>
  );
};
